//About page view
import Barba from 'barba.js'
import $ from 'jquery'
import worksMenuToggle from 'modules/worksmenu'
//Progressive from

var Work = Barba.BaseView.extend({
    namespace: "work",
    onEnter: function() {
    },
    onEnterCompleted: function() {
        this._construct()
        $(".js-open-works").click(function(){
            $('body').addClass('js-works-open');
            $('.active').removeClass('active');
            $('.main-menu .js-works-trigger').addClass('active');
            $('html, body').animate({scrollTop : 0},800);
            console.log("open")
        });
    },
    onLeave: function() {
        this.destroy()
    },
    $el: null,
    _construct: function() {
    },
    destroy: function() {

    }
});
export default Work;



// WEBPACK FOOTER //
// ./source/scripts/modules/barbaviews/work.js